<template>
  <v-app v-if="articleInfoValue">
    <v-container fluid class="article-actions">
      <v-row>
        <v-col cols="2">
          <v-subheader>عنوان</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="عنوان" v-model="title"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>دسته بندی</v-subheader>
        </v-col>
        <v-col cols="8">
          <ckeditor v-model="description"></ckeditor>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn
          class="ml-4 white--text font-weight-bold pink darken-1"
          @click="editHandler"
        >
          ثبت کردن
        </v-btn>

        <router-link to="/place/rent-type">
          <v-btn class="white--text font-weight-bold indigo lighten-2">
            انصراف
          </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      id: this.$route.params.id,
      shortDescription: "",
      description: "",
      link: "",
      staticContentTypeId: 0,
      title: "",
      image: null,
      list: [],
      items: [],
      selectItem: null,
    };
  },
  computed: {
    ...mapGetters(["tokenValue", "articleInfoValue", "itemList"]),
  },
  methods: {
    async editHandler() {
      await axios
        .post(
          "http://api.karaclub.com/api/RentType/Add",
          {
            title: this.title,
            description: this.description,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then(() => {
          this.$router.push("/place/rent-type");
        });
    },
  },
};
</script>

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
</style>